import React from "react";
import { Typography } from "@mui/material";

const Headings = ({ heading, subHeading }) => {
  return (
    <>
      <Typography
        fontSize="clamp(2rem, 4vw, 3.5rem)" // Responsive font size for the heading
        sx={{ mb: 2, fontWeight: "bold", textAlign: "left" }}
      >
        {heading}
      </Typography>
      <Typography
        fontSize="clamp(12px, 1vw, 14px)" // Responsive font size starting at 14px
        sx={{ mb: 4, textAlign: "left" }}
      >
        {subHeading}
      </Typography>
    </>
  );
};

export default Headings;
